/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Build_Your_Own_Ai_Mentor20Inputs */

const en__field_enum_build_your_own_ai_mentor20 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Mentor20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teacher`)
};

const de__field_enum_build_your_own_ai_mentor20 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Mentor20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrende`)
};

/**
* | output |
* | --- |
* | "Teacher" |
*
* @param {_Field_Enum_Build_Your_Own_Ai_Mentor20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_build_your_own_ai_mentor20 = /** @type {((inputs?: _Field_Enum_Build_Your_Own_Ai_Mentor20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Build_Your_Own_Ai_Mentor20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_build_your_own_ai_mentor20(inputs)
	return de__field_enum_build_your_own_ai_mentor20(inputs)
});
export { _field_enum_build_your_own_ai_mentor20 as "_field_enum_BUILD_YOUR_OWN_AI_MENTOR" }